import React from 'react';

const gtag = function gtag(...args) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(args);
};
const useOptimize = (experimentId) => {
    const [variant, setVariant] = React.useState(null);
    const defaultTimeout = 800;
    const timeoutRef = React.useRef();
    const updateVariant = React.useCallback(
        (v) => {
            clearTimeout(timeoutRef.current);
            setVariant(v != null ? Number(v) : 0); // defaults to default/"0" variant
        },
        [setVariant]
    );
    const getVariantFromOptimize = React.useCallback(() => {
        const value =
            window.google_optimize && window.google_optimize.get(experimentId);
        updateVariant(value);
    }, [experimentId, updateVariant]);
    const delayedInit = React.useCallback(() => {
        if (window && window.google_optimize) {
            getVariantFromOptimize();
        } else {
            timeoutRef.current = setTimeout(
                getVariantFromOptimize,
                defaultTimeout
            );
        }
    }, [getVariantFromOptimize]);
    React.useEffect(() => {
        const { dataLayer } = window;
        if (dataLayer) {
            const hideEnd = dataLayer && dataLayer.hide && dataLayer.hide.end;
            if (hideEnd) {
                dataLayer.hide.end = () => {
                    delayedInit();
                    hideEnd();
                };
            } else {
                delayedInit();
            }
            gtag('event', 'optimize.callback', {
                name: experimentId,
                callback: updateVariant,
            });
        }
        return () => {
            clearTimeout(timeoutRef.current);
            gtag('event', 'optimize.callback', {
                name: experimentId,
                callback: updateVariant,
                remove: true,
            });
        };
    }, [experimentId, updateVariant, delayedInit]);
    return [variant];
};
export default useOptimize;
